import { firmId, movieInfoQsUrl } from "@/lib/env";
import { type Movie, type MovieInfoQuery, type Show } from "@/lib/movieinfo/movieinfotypes";
import { gql, GraphQLClient } from 'graphql-request'; // will become graffle

const graphQLClient = new GraphQLClient(movieInfoQsUrl, { method: "GET" });

const query = gql`
  query($firmId: Int!) {
    showQuery {
        getShows(firmId: $firmId) {
            screenName
            ticketSaleUrl
            showType
            showInfo
            showStart
            movieMainVersionId
            movieTitle
            location
            versionTags {
                tag
                type
            }
        }
    }
    movieQuery {
        getCurrentMovies( firmId: $firmId ) {
            mainVersionId
            premiere
            sanityImagePosterUrl
        }
    }
}
`;

export default async function getShowsAndMovies() {
    const data = await graphQLClient.request<MovieInfoQuery>(query, { firmId });

    return data.showQuery?.getShows?.map(sh => {
        const movie = data.movieQuery!.getCurrentMovies!.find(m => m?.mainVersionId === sh?.movieMainVersionId)!;
        const shm: ShowWithMovie = {
            ...sh!,
            movie
        };
        return shm;
    });

}

export type ShowWithMovie = Show & {
    movie: Movie;
}